"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayAvg = void 0;
/**
 * średnia wartośc z tablicy
 * @param array tablica do sumowania
 * @param prop pole w wierszu podlegające sumowaniu, można pominąć
 */
function arrayAvg(array, prop) {
    if (prop) {
        return array.reduce((a, b) => a[prop] + b[prop], 0) / array.length;
    }
    else {
        return array.reduce((a, b) => a + b, 0) / array.length;
    }
}
exports.arrayAvg = arrayAvg;
//# sourceMappingURL=arrayAvg.js.map